import { bindActionCreators } from "redux";
import { Box, Button, Hidden, useTheme, withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { getCpf } from "../../shared/helper/infoUsuario";
import { TK_TIPOS_ACAO_SELECAO_SERVICO, trackServiceSelectORA } from "../../shared/helper/tracker";
import LoadingAvaliacao from "../../shared/template/LoadingAvaliacao";
import MeuInssModal from "../../shared/template/MeuInssModal";
import React, { Component } from "react";
import starIcon from "../../assets/fonts/govbr/dsgov-ico-star.svg";
import starIconDark from "../../assets/fonts/govbr/dsgov-ico-star-dark.svg";
import {
  limparAvaliacoes,
  obterLinkDireto,
  redirecionarParaAvaliacaoLinkDireto,
} from "./actions";
import { formatarCpf } from "shared/helper/formatadores";

const styles = (theme) => ({
  avaliacao: {
    display: "flex",
    flexDirection: "column",
    with: "100%",
    alignItems: "center",
    fontWeight: "600",
    color: theme.apps.avaliacao.color,
  },
});

class Avaliacao extends Component {
  constructor(props) {
    super(props);
    this.gerarLinkDireto = this.gerarLinkDireto.bind(this);
    this.trackAvaliacao = this.trackAvaliacao.bind(this);
    this.handleBtnOpenModal = this.handleBtnOpenModal.bind(this);
    this.handlerOnCloseModalBtnClick =
      this.handlerOnCloseModalBtnClick.bind(this);
    this.handlerMainModalBtnOnClick =
      this.handlerMainModalBtnOnClick.bind(this);
    this.handlerRedirecionarLinkAvaliacao =
      this.handlerRedirecionarLinkAvaliacao.bind(this);
    this.state = { open: false };
  }

  componentDidUpdate(prevProps) {
    let { links, servico } = this.props;
    if (prevProps.servico !== servico) {
      this.props.limparAvaliacoes();
    } else {
      //verifica se o target está preenchido para  evitar envio duplo de comando de avaliar pois na aplicação há 2 rodapes (1 oculto)
      if (prevProps.links !== links && links[servico] && this.target) {
        this.props.limparAvaliacoes();
        this.handlerRedirecionarLinkAvaliacao();
      }
    }
  }

  handleBtnOpenModal = (e) => {
    this.target = e.target;
    this.props.limparAvaliacoes();
    this.setState({ open: true });
  };

  handlerOnCloseModalBtnClick = () => {
    this.props.limparAvaliacoes();
    this.setState({ open: false });
  };

  handlerMainModalBtnOnClick = () => {
    if (this.props.mensagem) {
      this.props.limparAvaliacoes();
      this.setState({ open: false });
    } else {
      this.trackAvaliacao();
      this.gerarLinkDireto();
    }
  };

  trackAvaliacao = () => {
    trackServiceSelectORA(
      TK_TIPOS_ACAO_SELECAO_SERVICO.FUNCIONALIDADE,
      `Avaliação de serviço (${this.props?.descricao})`
    );
  };

  gerarLinkDireto() {
    let { servico } = this.props;
    let cpf = formatarCpf(getCpf());        
    let buscarLink = !(this.props.links && this.props.links[servico]);
    if (buscarLink) {
      this.props.obterLinkDireto(cpf, servico);
    }
  }

  handlerRedirecionarLinkAvaliacao = () => {
    let { links, servico } = this.props;
    if (!links["0"]) {
      if (links[servico]) {
        window.open(links[servico], "_system");
        this.setState({ open: false });
      }
    }
  };

  render() {
    let { descricao, esperandoRespostaSolicitacao, mensagem, classes } =
      this.props;

    return (
      <React.Fragment>
        <div className={classes.avaliacao}>
          <Box p={1} />
          <span>Avalie este serviço</span>

          <Button onClick={this.handleBtnOpenModal} style={{border: '0px'}} aria-label="Avaliar este serviço">
            <Star />
          </Button>
          <Hidden smUp>
            <Box p={3} />
          </Hidden>
          <Hidden xsDown>
            <Box p={1} />
          </Hidden>
        </div>
        <MeuInssModal
          open={this.state.open}
          handleClose={this.handlerOnCloseModalBtnClick}
          handleAction={this.handlerMainModalBtnOnClick}
          action={mensagem ? "Fechar" : "Avaliar"}
          title="Avalie este serviço"
          subtitle="Sua experiência pode ser ainda melhor."
          closeAfterMainAction={false}
          actionDisabled={esperandoRespostaSolicitacao}
        >
          <ModalText
            descricao={descricao}
            esperandoRespostaSolicitacao={esperandoRespostaSolicitacao}
            mensagem={mensagem}
          />
        </MeuInssModal>
      </React.Fragment>
    );
  }
}

const Star = () => {

  const theme = useTheme();
  const isDarkTheme = theme.palette.mode === "dark";

  const starCount = 5; // Número de estrelas
  const stars = Array.from({ length: starCount }, (_, i) => (
    <img key={i} style={{ maxWidth: "32px" }} src={isDarkTheme ? starIconDark : starIcon} alt="" />
  ));

  return <>{stars}</>;
};


const ModalText = ({ descricao, esperandoRespostaSolicitacao, mensagem }) => {
  return mensagem ? (
    <ModalTextErro mensagem={mensagem} />
  ) : esperandoRespostaSolicitacao ? (
    <ModalTextWait />
  ) : (
    <ModalTextPrevia descricao={descricao} />
  );
};

const ModalTextPrevia = ({ descricao }) => (
  <section>
    <p>
      Você usou o serviço <b>{descricao}</b>.
    </p>
    <p>Você será direcionado para https://www.servicos.gov.br/</p>
  </section>
);

const ModalTextWait = () => (
  <section>
    <LoadingAvaliacao />
    <p>
      Comunicando com{" "}
      <a href="https://www.servicos.gov.br/">https://www.servicos.gov.br/</a>
    </p>
  </section>
);

const ModalTextErro = ({ mensagem }) => (
  <section>
    <p>O serviço de avaliação se encontra indisponível.</p>
    <p>{mensagem}</p>
    <p>
      Mais informações em:{" "}
      <a href="https://www.servicos.gov.br/">https://www.servicos.gov.br/</a>
    </p>
  </section>
);

const mapStateToProps = (state) => ({
  esperandoRespostaSolicitacao: state.avaliacao.esperandoRespostaSolicitacao,
  mensagem: state.avaliacao.mensagem,
  avaliacoes: state.avaliacao.avaliacoes,
  links: state.avaliacao.links,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      obterLinkDireto,
      redirecionarParaAvaliacaoLinkDireto,
      limparAvaliacoes,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Avaliacao));
